import "prismjs/components/prism-java";
import "prismjs/components/prism-scala";
